import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const tasksApi = createApi({
  reducerPath: 'tasksApi',
  baseQuery: baseQueryWithReauth,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: (params) => {
        return {
          url: 'tasks',
          params: params,
        };
      },
      providesTags: ['Tasks'],
    }),

    getTaskDetails: builder.query({
      query: (id) => ({
        url: `tasks/details/${id}`,
      }),
    }),

    createTask: builder.mutation({
      query: ( task ) => ({
        url: `tasks`,
        method: 'POST',
        body: task,
      }),
      invalidatesTags: ['Tasks'],
      transformResponse: (response) => {
        return response;
      },
    }),
    bulkUpdateTasks: builder.mutation({
      query: ( tasks ) => ({
        url: 'tasks/bulk/update',
        method: 'PATCH',
        body: tasks,
      }),
      invalidatesTags: ['Tasks'],
      transformResponse: (response) => {
        return response;
      },
    }),
    deleteTask: builder.mutation({
      query: ( task ) => ({
        url: `tasks/${task._id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Tasks'],
      transformResponse: (response) => {
        return response;
      },
    }),
    getTaskLogs: builder.query({
      query: ({ id, limit = 100, skip = 0 }) => ({
        url: `tasks/${id}/logs`,
        params: { limit, skip },
      }),
    }),
    undoLastChange: builder.mutation({
      query: () => ({
        url: 'tasks/undo',
        method: 'POST',
      }),
      invalidatesTags: ['Tasks'],
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskDetailsQuery,
  useLazyGetTaskDetailsQuery,
  useCreateTaskMutation,
  useBulkUpdateTasksMutation,
  useDeleteTaskMutation,
  useGetTaskLogsQuery,
  useUndoLastChangeMutation,
} = tasksApi;
